import { showCommonPopupAction } from 'js/components/common/popups/CommonPopup';
import { LAYER } from 'js/components/common/PopupManager';

import { FreeSpin2BonusPopup } from './FreeSpin2BonusPopup';

export const showFreeSpin2BonusPopupAction = ({
    id,
    betConfigurations,
    gameCodeNames,
    showGamesList,
    dialogId,
    ...props
}) => {
    return showCommonPopupAction({
        layer: LAYER.BONUS,
        ...props,
        id,
        betConfigurations,
        gameCodeNames,
        showGamesList,
        dialogId,
        component: FreeSpin2BonusPopup
    });
};
